import { createReducer, on } from '@ngrx/store';
import { selectNode, toggleNode } from './ServiceCategoryTreeAction';

export interface TreeMenuState {
    expandedKeys: { [key: string]: boolean };
    selectedKey?: string;
}

export const initialTreeMenuState: TreeMenuState = {
    expandedKeys: {},
    selectedKey: undefined
};

export const ServiceCategoryReducer = createReducer(
    initialTreeMenuState,
    on(toggleNode, (state, { key, expanded }) => ({
        ...state,
        expandedKeys: { ...state.expandedKeys, [key]: expanded }
    })),
    on(selectNode, (state, { key }) => ({
        ...state,
        selectedKey: key
    }))
);